module.exports = __webpack_public_path__ + "img/BRADESCARD_logo_BCO.0bb441ec.png";